import React from 'react';
import { CheckCircle, Clock, AlertCircle } from 'lucide-react';

const BookingStatusBreakdown = ({ bookingsAnalytics = {} }) => {
  const byStatus = bookingsAnalytics.by_status || {};

  return (
    <div className="rounded-2xl border border-gray-200/80 bg-white dark:border-gray-700 dark:bg-gray-900 shadow-sm p-4 sm:p-6">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-50 mb-4">Booking Status</h3>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />
            <span className="text-sm text-gray-600 dark:text-gray-400">Completed</span>
          </div>
          <span className="text-sm font-semibold text-gray-900 dark:text-gray-50">
            {byStatus.completed || 0}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-amber-600 dark:text-amber-400" />
            <span className="text-sm text-gray-600 dark:text-gray-400">Pending</span>
          </div>
          <span className="text-sm font-semibold text-gray-900 dark:text-gray-50">
            {byStatus.pending || 0}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <AlertCircle className="w-4 h-4 text-red-600 dark:text-red-400" />
            <span className="text-sm text-gray-600 dark:text-gray-400">Cancelled</span>
          </div>
          <span className="text-sm font-semibold text-gray-900 dark:text-gray-50">
            {byStatus.cancelled || 0}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BookingStatusBreakdown;
